import { render, staticRenderFns } from "./BCurrentVoltage.vue?vue&type=template&id=167bfe33&scoped=true"
import script from "./BCurrentVoltage.vue?vue&type=script&lang=ts"
export * from "./BCurrentVoltage.vue?vue&type=script&lang=ts"
import style0 from "./BCurrentVoltage.vue?vue&type=style&index=0&id=167bfe33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167bfe33",
  null
  
)

export default component.exports